var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--sub"
  }, [_c('sub-visual', {
    attrs: {
      "visual": '전자제조지원센터'
    }
  }), _c('div', {
    staticClass: "tab-list--primary-wrap"
  }, [_c('ul', {
    staticClass: "tab-list tab-list--primary"
  }, [_c('li', [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("센터개요")])], 1), _c('li', {
    staticClass: "on"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/about/equipments"
    }
  }, [_vm._v("장비소개")])], 1), _c('li', [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/about/location"
    }
  }, [_vm._v("오시는 길")])], 1)])]), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('section', {
    staticClass: "page-section  page-section--first"
  }, [_c('tit-primary', {
    attrs: {
      "sc": "equipment",
      "tit": "전자보드와 목업을 지원할 수 있는 전문장비를 보유하고 있습니다.",
      "titTxt": "전문 엔지니어가 제품개발과 생산을 지원합니다."
    }
  }), _c('h4', {
    staticClass: "tit--sm bar-txt"
  }, [_vm._v(" 장비구성 ")]), _c('div', {
    staticClass: "border-top border-2 border-color-black page-text color-grey"
  }, [_c('sub-list-primary', {
    attrs: {
      "tit": "전자제조장비",
      "sc": "전자부품실장(SMT) 및 수삽부품 조립라인 (총 3라인) 40여종",
      "spacing": "min-w-120px min-w-lg-160px mr-md-18 mr-xl-48"
    }
  }), _c('sub-list-primary', {
    attrs: {
      "tit": "목업장비",
      "sc": "기구설계, 기구제작, 시제품 외형(목업)제작 지원장비 10여종",
      "spacing": "min-w-120px min-w-lg-160px mr-md-18 mr-xl-48"
    }
  }), _c('sub-list-primary', {
    attrs: {
      "tit": "측정평가/디버깅/AS장비",
      "sc": "전자 실험 및 측정평가, 신뢰성검사, 부품 리페어 장비 10여종",
      "spacing": "min-w-120px min-w-lg-160px mr-md-18 mr-xl-48"
    }
  }), _c('sub-list-primary', {
    attrs: {
      "tit": "사후관리/마케팅",
      "sc": "공용AS조립룸, 스튜디오, ",
      "spacing": "min-w-120px min-w-lg-160px mr-md-18 mr-xl-48"
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('v-btn', {
          staticClass: "pa-4",
          attrs: {
            "text": "",
            "large": "",
            "height": "auto",
            "href": "https://kea-editor-blacksmith.uxi.kr",
            "target": "_blank"
          }
        }, [_c('span', [_vm._v(" 제품정보지원 플랫폼 ")]), _c('v-icon', {
          staticClass: "ml-4",
          attrs: {
            "small": ""
          }
        }, [_vm._v(" mdi-open-in-new ")])], 1)];
      },
      proxy: true
    }])
  })], 1)], 1), _c('section', {
    staticClass: "page-section"
  }, [_c('h4', {
    staticClass: "tit--sm bar-txt"
  }, [_vm._v(" 주요장비 ")]), _c('sub-card-list', {
    attrs: {
      "tit": "전자제조장비",
      "className": "mb-50 mb-lg-80"
    }
  }, [_c('v-row', {
    staticClass: "row--y-large",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('sub-image-card', {
    attrs: {
      "image": "/images/sub/about/equipments/s2-img1-1.jpg",
      "tit": "전자부품실장라인(2라인)"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('sub-image-card', {
    attrs: {
      "image": "/images/sub/about/equipments/s2-img1-2.jpg",
      "tit": "전자보드조립라인(1라인)"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('sub-image-card', {
    attrs: {
      "image": "/images/sub/about/equipments/s2-img1-3.jpg",
      "tit": "수삽부품 조립라인"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('sub-image-card', {
    attrs: {
      "image": "/images/sub/about/equipments/s2-img1-4.jpg",
      "tit": "레이저 마커"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('sub-image-card', {
    attrs: {
      "image": "/images/sub/about/equipments/s2-img1-5.jpg",
      "tit": "부품검사기(X-ray)"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('sub-image-card', {
    attrs: {
      "image": "/images/sub/about/equipments/s2-img1-6.jpg",
      "tit": "디버깅"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('sub-image-card', {
    attrs: {
      "image": "/images/sub/about/equipments/s2-img1-7.jpg",
      "tit": "계측기기"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('sub-image-card', {
    attrs: {
      "image": "/images/sub/about/equipments/s2-img1-8.jpg",
      "tit": "수삽"
    }
  })], 1)], 1)], 1), _c('sub-card-list', {
    attrs: {
      "tit": "목업장비",
      "className": "mb-50 mb-lg-80"
    }
  }, [_c('v-row', {
    staticClass: "row--y-large",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('sub-image-card', {
    attrs: {
      "image": "/images/sub/about/equipments/s2-img2-1.jpg",
      "tit": "산업용 3D 프린터(SLA)"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('sub-image-card', {
    attrs: {
      "image": "/images/sub/about/equipments/s2-img2-2.jpg",
      "tit": "산업용 3D 프린터(FDM)"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('sub-image-card', {
    attrs: {
      "image": "/images/sub/about/equipments/s2-img2-3.jpg",
      "tit": "산업용 3D 스캐너"
    }
  })], 1)], 1)], 1), _c('sub-card-list', {
    attrs: {
      "tit": "측정평가/디버깅장비"
    }
  }, [_c('v-row', {
    staticClass: "row--y-large",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('sub-image-card', {
    attrs: {
      "image": "/images/sub/about/equipments/s2-img3-1.jpg",
      "tit": "회로설계 툴"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('sub-image-card', {
    attrs: {
      "image": "/images/sub/about/equipments/s2-img3-2.jpg",
      "tit": "항온항습기"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('sub-image-card', {
    attrs: {
      "image": "/images/sub/about/equipments/s2-img3-3.jpg",
      "tit": "부품 리웍스테이션"
    }
  })], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "page-section page-section--last"
  }, [_c('h4', {
    staticClass: "tit--sm bar-txt"
  }, [_vm._v(" 장비사용문의 ")]), _c('v-card', {
    attrs: {
      "elevation": "0",
      "color": "grey-light",
      "rounded": ""
    }
  }, [_c('div', {
    staticClass: "pa-20 pa-md-30 pa-lg-40"
  }, [_c('v-row', {
    staticClass: "row--x-large",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "icon-wrap"
  }, [_c('i', {
    staticClass: "icon icon-tel"
  })])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('h4', {
    staticClass: "tit--sm"
  }, [_vm._v(" 02-6388-6192 ")])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "min-w-120px min-w-lg-200px",
    attrs: {
      "to": "/rental/equipments",
      "large": "",
      "rounded": "",
      "color": "primary",
      "elevation": "0"
    }
  }, [_vm._v(" 장비 예약 바로가기 ")])], 1)], 1)], 1)])], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }